import { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiPickersPopper: Components<CssVarsTheme>['MuiPickersPopper'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      marginTop: theme.spacing(1),
      boxShadow: theme.customShadow.secondary.center
    })
  }
};

export const MuiYearCalendar: Components<CssVarsTheme>['MuiYearCalendar'] = {
  styleOverrides: {
    root: {
      '& .MuiPickersYear-yearButton.Mui-disabled': {
        color: 'var(--mui-palette-text-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'unset'
      }
    }
  }
};
